/**
 * Phone number validation regex
 * US format: Exactly 10 digits (plain) or fully formatted (XXX) XXX-XXXX
 * International format: Flexible with + prefix
 * Note: Only validates complete formats, partial inputs during typing are handled by the input component
 */
export const PHONE_NUMBER_REGEX = /^(\d{10}|\(\d{3}\)\s\d{3}-\d{4}|\+\d{1,4}\s?\d{4,14})$/

/**
 * Normalize a phone number to the formatted (XXX) XXX-XXXX format
 * Handles various input formats:
 * - "714-555-9876" → "(714) 555-9876"
 * - "7145559876" → "(714) 555-9876"
 * - "(714) 555-9876" → "(714) 555-9876" (no change)
 * - "" or undefined → ""
 *
 * @param phone - The phone number string to normalize
 * @returns Normalized phone in (XXX) XXX-XXXX format, or original if not a valid 10-digit number
 */
export const normalizePhoneNumber = (phone?: string | null): string => {
  if (!phone) return ''

  // If already in correct format, return as-is
  if (/^\(\d{3}\)\s\d{3}-\d{4}$/.test(phone)) {
    return phone
  }

  // Strip all non-digit characters
  const digits = phone.replace(/\D/g, '')

  // If we have exactly 10 digits, format it
  if (digits.length === 10) {
    return `(${digits.slice(0, 3)}) ${digits.slice(3, 6)}-${digits.slice(6)}`
  }

  // Otherwise return original (might be international or incomplete)
  return phone
}
